// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"265":"23d6e01c","936":"35c94ebd"}[chunkId] + ".chunk.css";
};